
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = function createStore(socket){
   console.log(socket);
    return new Vuex.Store( {
        state: () => ({ 
            token: '11828ad72e85bcd0149c7fea459a18850c2b9c72',

            qrcode: 'hellothere',
            userForm: { name: 'Andi', lastName: 'Scharf', birthDay: '30.08.2000' },
            
            qrCodeAccessInfo: {name: '', surname: '', company: '', street: '', postalCode: '', location: '', phone: '', email: ''}
            
        }),
        mutations: {
            increment(state) {
                state.count++
            },
            'set-token': function(state, token){
                state.token = token;
            },
            'set-qrcode': function(state, qrcode){
                state.qrcode = qrcode
            }
        },
        actions:{
            
        },
        getters: {
            token(state) {
                return state.token
            }
        }
})
}
export default store;